<template>
    <div>
        <div class="d-flex justify-end mx-6" style="width: 400px; margin-top: -45px; right: 0px; position: absolute">
            <v-menu offset-y left :close-on-content-click="false" min-width="auto" ref="menu" v-model="openDates">
                <template v-slot:activator="{ on, attrs }">
                    <!-- <v-text-field class="mr-1 no-shadow" :color="setCalendar == 0 ? 'primary' : 'gray'" :outlined="setCalendar == 0" solo elevation="0" label="Data do pedido" dense v-model="dateRangeText" -->
                    <v-text-field elevation="0" outlined dense v-model="dateRangeText" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" hide-details style="flex: 0 0 270px"></v-text-field>
                </template>
                <v-date-picker no-title v-model="customDates" range>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" elevation="0" @click="applyDate()">
                        {{ $t("common.ok") }}
                    </v-btn>
                </v-date-picker>
            </v-menu>
            <v-btn @click="extendAWeek()" class="ml-1" text color="primary">{{ $t('common.dates.extendOneWeek') }}</v-btn>
        </div>
        <v-card outlined style="overflow: hidden;">
            <div class="gantt" style="position: relative;">
                <!-- <v-divider></v-divider>  -->


                <div class="d-flex gantt-columns" v-if="activeItems.length">
                    <!-- <v-divider vertical></v-divider> -->
                    <div class="gantt-column">
                        <div class="no-border-top">ID</div>
                        <template v-for="group in grouped">

                            <div :key="`Y${group.group}`">
                                <v-card color="#f3f3f3" elevation="0" tile class="d-flex align-center"
                                    style="position: absolute; margin-top: -10px; margin-left: -10px; width: 100%"
                                    height="47">
                                    <v-img v-if="group.pack" :src="group.pack.image" max-width="47" height="47"></v-img>
                                    <v-avatar size="47" v-else></v-avatar>
                                    <div class="px-3 d-flex" style="width: 100%" v-if="group.pack">
                                        <strong>{{ group.pack.name }}</strong>
                                        <v-spacer></v-spacer>
                                        <!-- <strong>{{ group.pack.insertions }}</strong> -->
                                        <!-- <strong class="ml-2">{{ $n(group.pack.finalPrice,'currency') }}</strong> -->
                                        <!-- <v-chip label x-small color="success" class="ml-2">{{ group.pack.percentDiscount | roundNumber }}% OFF</v-chip> -->
                                    </div>
                                    <div v-else>
                                        <strong>Formatos regulares</strong>
                                    </div>
                                </v-card>
                            </div>
                            <template v-for="(task, t) in activeItems">
                                <div v-if="task.meta.group == group.group" :key="`X${group.group}-${t}`"
                                    :class="openList.includes(task.id) ? '--opened' : '--closed'">
                                    {{ task.id + 1 }}

                                </div>
                            </template>
                        </template>
                    </div>
                    <template v-for="(key, indexKey) in activeHeaders">
                        <div class="gantt-column" :key="indexKey" v-if="activeTypeHeaders[indexKey].type !== 'spacer'">
                            <div v-html="$t(`common.data.${key}`)" class="no-border-top"></div>
                            <template v-for="group in grouped">
                                <div :key="`Z${group.group}`"></div>
                                <template v-for="(task, t) in activeItems">
                                    <template v-if="task.meta.group == group.group">
                                        <template v-if="!task.pack">
                                            <div v-if="activeTypeHeaders[indexKey].type == 'text'" v-html="task.info[key]"
                                                :key="`A${group.group}-${t}`"
                                                :class="openList.includes(task.id) ? '--opened' : '--closed'"></div>
                                            <div v-if="activeTypeHeaders[indexKey].type == 'currency'"
                                                :key="`B${group.group}-${t}`"
                                                :class="openList.includes(task.id) ? '--opened' : '--closed'">{{
                                                    $n(task.info[key],
                                                        'currency') }}</div>
                                            <div v-if="activeTypeHeaders[indexKey].type == 'total'"
                                                :key="`t${group.group}-${t}`"
                                                :class="openList.includes(task.id) ? '--opened' : '--closed'">{{
                                                    $n(countTotal(task)) }}</div>
                                        </template>
                                        <div v-else class="-opened" :key="`C${group.group}-${t}`"></div>
                                    </template>
                                </template>
                            </template>
                        </div>
                        <div class="gantt-column" :key="`gc-${indexKey}`" style="width: auto; flex: 1 1 100%" v-else>
                            <div></div>
                            <template v-for="group in grouped">
                                <div :key="`Z${group.group}`"></div>


                                <template v-for="(task, t) in activeItems">
                                    <template v-if="task.meta.group == group.group">
                                        <div class="--closed" :key="`D${group.group}-${t}`"></div>
                                    </template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <div class="gantt-column">
                        <div class="no-border-top">Total</div>
                        <template v-for="(group) in grouped">
                            <div :key="`Z${group.group}-${i}`">

                            </div>

                            <template v-for="(task, t) in activeItems">
                                <template v-if="task.meta.group == group.group">

                                    <div v-if="task.meta.group == group.group" :key="`X${group.group}-${t}`"
                                        :class="openList.includes(task.id) ? '--opened' : '--closed'">
                                        <span class="font-weight-bold"
                                            :class="group.items[task.id].sum == group.items[task.id].info.insertions ? 'green--text' : 'red--text'">{{
                                                group.items[task.id].sum }} de {{ group.items[task.id].info.insertions }}</span>

                                    </div>

                                </template>
                            </template>
                        </template>
                    </div>


                    <div class="gantt-dates" v-if="dates.length">
                        <div class="--month-label --fixed" id="monthLabelFixed"
                            style="top:30px; box-shadow: 3px 0 3px #fff, 0 1px 0 0 #fff; background: #fff">{{ dateLabel }}
                        </div>

                        <div class="gantt-column --date --relative" v-for="(day, i) in dateSet" :key="i">



                            <div class="no-border-top px-1 d-flex --date-cell justify-start flex-column"><span
                                    style="line-height: 12px; text-justify: center">
                                    <div class="text-center">{{ day.day | dateDay }}</div>
                                    <div class="mx-auto text-center font-weight-normal"
                                        style="height: 12px; line-height: 12px; font-size: .75em">
                                        <!-- <v-chip x-small class="pa-1">-->{{ day.day | weekDay }}<!-- </v-chip>--></div>
                                </span>
                                <div class="--month-label --m-l" :id="getIdOfMonth(day.day, i)"
                                    v-if="isFirstDayOfMonth(day.day, i)">{{ day.day | dateMonth }}, {{ day.day | dateYear }}
                                </div>
                            </div>
                            <template v-for="group in grouped">
                                <div :key="`Z${group.group}-${i}`"></div>
                                <!-- <template  v-if="task.meta.group == group.group"> -->
                                <v-card tile class="d-flex justify-center day pa-0" elevation="0"
                                    :id="`${task.id}--${day.day}`"
                                    :color="selectedDates[task.id][`${day.day}`] && selectedDates[task.id][`${day.day}`].insertions ? 'primary' : ''"
                                    :dark="selectedDates[task.id][`${day.day}`] && selectedDates[task.id][`${day.day}`].insertions ? true : false"
                                    v-for="task in activeItems" :key="`Z${group.group}-${i}-${task.id}`">
                                    <template v-if="selectedDates[task.id][`${day.day}`]">
                                        <v-text-field style="max-width: 55px; min-width: 55px; padding: 0;" min="0" step="1"
                                            outlined v-model="selectedDates[task.id][`${day.day}`].insertions" type="number"
                                            @input="checkIsNull(task.id, day.day)" hide-details dense></v-text-field>
                                    </template>
                                    <div v-else @click="updateCell(task.id, day.day)">
                                        <v-text-field style="max-width: 55px; min-width: 55px; padding: 0;" outlined min="0"
                                            step="1" type="number" hide-details dense></v-text-field>
                                    </div>
                                </v-card>
                                <!-- </template> -->
                            </template>

                        </div>

                    </div>
                    <!-- <v-divider vertical></v-divider> -->
                    <!--  <div class="gantt-column">
                <div></div>
                <div v-for="(task, t) in activeItems" :key="t" :class="openList.includes(task.id) ? '--opened' : '--closed'">
                    <v-btn x-small fab color="primary" outlined size="22" @click="open(task.id)">
                        <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </div> -->

                </div>
                <div v-if="!activeItems.length" class="mt-n3 pb-15" style=" position: relative">
                    <v-divider></v-divider>
                    <div class="pa-3 text-center grey--text text-p">{{ $t('common.data.noDataAvailable') }}</div>
                    <v-divider></v-divider>
                </div>

                <!-- <v-divider></v-divider> -->
            </div>
        </v-card>
        <div class="d-flex pt-3">
            <v-spacer></v-spacer>
            <template v-if="hasChange">
            <v-btn text @click="closeView()">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" :disabled="hasError" @click="toConfirm()">{{ $t('common.editBtn') }}</v-btn>
        </template>
        <template v-else>
            <v-btn color="primary" elevation="0" @click="closeView()">{{ $t('common.ok') }}</v-btn>
        </template>
        </div>
        <v-dialog v-model="confirm.show" width="540">
            <v-card class="mx-auto">
                <v-card-title>{{ $t('sales.ordersList.modalPlacement.confirm.title') }}</v-card-title>
                <v-card-text>
                    <div>{{ $t('sales.ordersList.modalPlacement.confirm.subtitle') }}</div>
                    <div>{{ $t('sales.ordersList.modalPlacement.confirm.text') }}.</div>
                    <div class="py-1">{{ $t('sales.ordersList.modalPlacement.confirm.textConfirmation', {text: confirmText}) }}</div>
                    <v-text-field outlined v-model="confirm.text"></v-text-field>
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                            <v-btn text @click="confirm.show = false">{{ $t('common.cancel') }}</v-btn>
                            <v-btn color="success" :loading="confirm.processing" elevation="0" @click="save()" :disabled="confirm.text !== $t('sales.ordersList.modalPlacement.confirm.confirm')">{{ $t('common.save') }}</v-btn>
                        
                    </div>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export default {
    data: () => ({
        confirm: {
            text: "",
            show: false,
            processing: false
        },
        hasErrors: false,
        customDatesText: "",
        openDates: false,
        customDates: [],
        dateLabel: "",
        openList: [],
        filter: {
            from: null,
            to: null
        },
        items: [],
        errorsFill: {},
        labels: []
        // dateSet: []

    }),
    props: {
        dates: Array,
        headers: Array,
        queryText: String,
        snap: Array,
        types: Array,
        callback: Function
    },
    mounted() {
        this.items = JSON.parse(JSON.stringify(this.snap))
        if (this.dates.length) {
            this.filter.from = this.dates[0]
            this.filter.to = this.dates[1]
        }
        this.customDates = JSON.parse(JSON.stringify(this.dates))
        this.filter.from = this.dates[0]
        this.filter.to = this.dates[1]
        setTimeout(() => {
            if (this.dates.length){
                let d = document.getElementsByClassName("gantt-dates")
                if(d.length){

                    d[0].addEventListener("scroll", () => {
                        const scrolled = document.getElementsByClassName("gantt-dates")[0]
                            .scrollLeft;
                        this.checkLabel(scrolled)
                    });
                }
            }
        }, 1500)

        this.loadMonthLabel()
    },

    beforeDestroy() {
        if (typeof window === "undefined") return;
        window.removeEventListener("scroll", () => {
            const scrolled = document.getElementsByClassName("gantt-dates")[0]
                .scrollLeft;
            this.checkLabel(scrolled)
        });
    },

    watch: {
        dates: {
            deep: true,
            handler(val) {
                this.filter.from = val[0]
                this.filter.to = val[1]
                this.loadMonthLabel()
            }
        },
        errorsFill: {
            deep: true,
            handler(r) {
                console.log('Errors', r)
                let s = false
                for (let a in r) {
                    console.log(r[a])
                    if (!r[a])
                        s = true
                }
                this.hasErrors = s
            }
        },
        customDates: {
            deep: true,
            handler(val) {
                this.filter.from = val[0]
                this.filter.to = val[1]
                this.loadMonthLabel()
            }
        },
        '$i18n.locale': {
            deep: true,
            handler() {
                this.loadMonthLabel()
            }
        }
    },
    computed: {
        confirmText(){
            return this.$t('sales.ordersList.modalPlacement.confirm.confirm')
        },
        hasChange(){
            let before = JSON.stringify(this.snap)
            let after = JSON.stringify(this.items)
            return before != after
        },
        hasError() {
            for (let group in this.grouped) {
                if (this.grouped[group].hasError)
                    return true
            }
            //     console.log('S', s)
            // let total = 0
            // s.selected.forEach((item) => {
            //     total += parseFloat(item.insertions)
            // })
            // this.errorsFill[x] = total == s.info.insertions
            // return `<span class="${total == s.info.insertions ? 'green--text' : 'red--text'} font-weight-bold">${total} of ${s.info.insertions}</span>`
            // })
            return false
        },
        dateRangeText() {
            let datesSelected = this.customDates;
            if (!datesSelected.length)
                return "";
            if (this.customDates.length == 2) {
                if (moment(this.customDates[0]).isBefore(this.customDates[1])) {
                    datesSelected = [
                        this.customDates[0],
                        this.customDates[1],
                    ];
                }
                else {
                    datesSelected = [
                        this.customDates[1],
                        this.customDates[0],
                    ];
                }
            }
            const dates = datesSelected.length
                ? [moment(datesSelected[0], "YYYY-MM-DD").format("L")]
                : [];
            if (datesSelected.length == 2)
                dates.push(moment(datesSelected[1], "YYYY-M-D").format("L"));
            if (datesSelected.length == 1)
                dates.push(moment(datesSelected[0], "YYYY-M-D").format("L"));
            return dates.join(" to ");
        },
        grouped() {
            const groups = {}
            this.activeItems.forEach(item => {
                if (!groups.hasOwnProperty(item.meta.group)) {
                    groups[item.meta.group] = {
                        items: [],
                        group: item.meta.group,
                        pack: item.meta.pack,
                        hasError: false
                    }
                }
                groups[item.meta.group].items[item.id] = { dates: {}, sum: 0, hasError: false }
                item.selected.forEach((i) => {
                    groups[item.meta.group].items[item.id].dates[`${i.year}-${i.month}-${i.monthDay}`] = i
                    groups[item.meta.group].items[item.id].sum += parseInt(i.insertions)
                })
                groups[item.meta.group].items[item.id].info = item.info
                groups[item.meta.group].items[item.id].hasError = groups[item.meta.group].items[item.id].sum != item.info.insertions
                if (groups[item.meta.group].items[item.id].hasError)
                    groups[item.meta.group].hasError = true
            })
            return groups
        },
        openedList() {
            const list = []
            this.openList.forEach((item) => {
                list.push(this.activeItems.indexOf(item.id))
            })
            return list
        },
        selectedDates() {
            const result = []

            this.items.forEach(item => {
                result[item.id] = {}
                item.selected.forEach((i) => {
                    let monthDay = moment(i.monthDay, 'DD').format('D')
                    result[item.id][`${i.year}-${i.month}-${monthDay}`] = i
                })
            })

            return result



        },
        activeHeaders() {
            const keys = []
            this.headers.forEach((h) => {
                keys.push(h.name)
            })
            // console.log('Object.keys(this.activeItems[0].info)', Object.keys(this.activeItems[0].info))
            return this.activeItems.length ? (Object.keys(this.activeItems[0].info)).filter((item, index) => { return keys.includes(item) }) : []
        },
        activeTypeHeaders() {
            return this.activeHeaders.length ? this.types.filter((item) => { return this.activeHeaders.includes(item.name) }) : []
        },
        activeItems() {
            // const dateRange = moment.range(moment(this.filter.from), moment(this.filter.to))
            // const dateResult = this.items.filter(item => {
            //     const itemRange = moment.range(moment(item.start), moment(item.end))
            //     return dateRange.intersect(itemRange)
            // })
            if (!this.items || !this.items.length) return []
            const dateResult = this.items
            return this.queryText.length ? dateResult.filter((data) => JSON.stringify(data).toLowerCase().indexOf(this.queryText.toLowerCase()) !== -1) : dateResult;
        },
        labelPosition() {
            if (this.dates.length) {
                const doc = document.getElementById('monthLabelFixed').getBoundingClientRect();

                return doc.left
            }
            return null
        },

        dateSet() {
            const result = []
            const from = moment(this.filter.to, 'YYYY-MM-DD')
            const to = moment(this.filter.from, 'YYYY-MM-DD')
            const diff = from.diff(to, 'days')
            for (let i = -1; i < diff; i++) {

                let day = moment(this.filter.from, 'YYYY-MM-DD').add(i, 'days');
                result.push({ day: day.add(1, 'days').format('YYYY-M-D'), tasks: [] })
            }
            return result
        }
    },

    methods: {
        toConfirm(){
            this.confirm.text = ''
            this.confirm.show = true
            this.confirm.processing = false
        },
        save(){
            this.confirm.processing = true
            this.callback(this.items)
        },
        closeView() {
            this.$emit('show', true)
        },
        extendAWeek() {
            let current = moment(this.customDates[1], 'YYYY-MM-DD')
            let newFinalDate = current.add(7, 'days').format('YYYY-MM-DD')
            console.log('newFinalDate', newFinalDate)
            this.customDates = [this.customDates[0], newFinalDate]
            this.filter.to = this.customDates[1]
        },
        applyDate() {
            // igual a 0? recebe o valor dos dias selecionados no filtro

            const dates = JSON.parse(JSON.stringify(this.customDates)); // da um parse para transforma a string em objeto e depois transforma em string dnv
            this.customDates = moment(dates[0]).isBefore(dates[1])
                ? [dates[0], dates[1]]
                : [dates[1], dates[0]]; //Verifica se o newDates [0] vem antes do [1] e ajusta
            this.openDates = false;
        },
        calc(s, x) {
            console.log('S', s)
            let total = 0
            s.selected.forEach((item) => {
                total += parseFloat(item.insertions)
            })
            this.errorsFill[x] = total == s.info.insertions
            return `<span class="${total == s.info.insertions ? 'green--text' : 'red--text'} font-weight-bold">${total} de ${s.info.insertions}</span>`
        },
        updateCell(item, day) {
            console.log('Item', item)
            console.log('Day', day)
            let d = moment(day, 'YYYY-MM-DD')
            let cell = {
                disabled: null,
                fill: false,
                insertions: "1",
                isToday: false,
                lock: false,
                month: parseInt(d.format('M')),
                monthDay: d.format('DD'),
                quantities: null,
                weekDay: d.day(),
                year: d.format('YYYY'),
            }
            this.items[item].selected.push(cell)

        },
        checkIsNull(item, day) {
            let d = moment(day, 'YYYY-MM-DD')
            let index = this.items[item].selected.findIndex(i => i.month == parseInt(d.format('M')) && i.monthDay == d.format('DD') && i.year == d.format('YYYY'))
            console.log('Index', index)
            if (this.items[item].selected[index].insertions == 0)
                this.items[item].selected.splice(index, 1)
        },
        countTotal(n) {
            console.log('NNN', n)
        },
        getDate(date, key) {
            switch (key) {
                case 'day': return date.day.day()
                case 'month': return date.day.month()
                case 'year': return date.day.year()
            }
        },
        open(id) {
            const index = this.openList.indexOf(id)
            if (!this.openList.includes(id))
                this.openList.push(id)
            else
                this.openList.splice(index, 1)
        },
        checkLabel(scroll) {
            let s = scroll + this.labelPosition + 10
            this.labels.forEach((label) => {
                if (s > label.left) {
                    this.dateLabel = label.text
                }
            })
        },
        offset(el) {
            const rect = el.getBoundingClientRect()
            return { top: rect.top, left: rect.left }
        },
        loadMonthLabel() {
            this.openList = []
            setTimeout(() => {
                const res = []
                const docs = document.getElementsByClassName('--m-l');
                for (var i = 0; i < docs.length; i++) {
                    let divOffset = this.offset(docs[i]);
                    res.push({ left: divOffset.left, text: docs[i].innerHTML, id: docs[i].id })
                }
                this.labels = res
                this.checkLabel(0)
            }, 300)
        },
        into(index, date) {

            // let compareDate = date;
            // let startDate = moment(this.activeItems[index].start, "YYYY-MM-DD");
            // let endDate = moment(this.activeItems[index].end, "YYYY-MM-DD").add(1, 'day');
            // return compareDate.isBetween(startDate, endDate) ? `background:${this.activeItems[index].color}` : ``;


        },
        isFirstDayOfMonth(date, index) {

            return moment(date, 'YYYY-MM-DD').date() == 1 || index == 0
        },
        getIdOfMonth(date, index) {
            return moment(date, 'YYYY-MM-DD').date() == 1 || index == 0 ? `dt-${moment(date, 'YYYY-MM-DD').format('YYYY-MM')}` : ''
        }
    }
}
</script>
<style lang="scss">
$--bc: rgba(0, 0, 0, 0.12);
$--red: #ffebee; // rgb(252,75,108);

.gantt {
    font-size: .83em;

    .--opened {
        margin-bottom: 300px !important;
        // transition: .1s all;
    }

    .--closed {
        white-space: wrap;
        margin-bottom: 0px !important;
        //transition: .1s all;
    }

    .--red {
        background: $--red;
    }

    .gantt-columns {
        width: 100%;
        margin-top: -2px;
    }

    .gantt-column {
        .v-text-field--outlined fieldset {
            border-width: 0px !important;
        }

        // border-right: 1px solid $--bc;
        &>div {
            display: block;
            flex: 1 1 100%;
            padding: 10px;
            height: 48px;
            line-height: 28px;
            border-top: 1px solid $--bc;

            &:first-child {
                font-weight: bold;
                font-size: 0.75rem;
                padding-left: 15px;
                padding-right: 15px;
                color: rgba(0, 0, 0, 0.6);
            }

            &.no-border-top {
                border-top: none;
            }
        }
    }

    .gantt-dates {
        flex: 1 1 60%;
        display: flex;
        overflow: scroll;
        border-left: 1px solid $--bc;
        margin-left: 0px;

        &>div {
            flex: 1 1 100%;

            &>div {
                padding: 5px;
                border-top: 1px solid $--bc;

                &:first-child {

                    font-weight: bold;
                }
            }

            .day {
                height: 48px;
                border-color: rgba(0, 0, 0, 0.12) !important;

                &.--red {
                    box-shadow: 1px 0 0 0 $--red;

                }
            }
        }
    }

    .--relative {
        position: relative;
    }

    .--month-label {
        position: absolute;
        background: #fff;
        white-space: nowrap;
        top: 30px;
        height: 10px;
        padding: 0 !important;
        border: none !important;
        font-weight: normal !important;
        line-height: 10px;
        text-transform: uppercase;

        &.--fixed {
            font-weight: bold;
            font-size: 0.75rem;
            padding-left: 15px !important;
            color: rgba(0, 0, 0, 0.6);
            z-index: 1;
        }
    }

    .--date {
        max-width: 50px;

        // border-right: 1px solid $--bc;
        &:last-child {
            //   border-right: none;
        }

        &:nth-child(odd) {
            .--date-cell {
                margin-top: 2px;
                margin-bottom: -2px;
                background-image: linear-gradient(180deg, #eee, #ffffff00, #ffffff00);
                //linear-gradient(90deg, #ccc #fff);
            }
        }
    }

    .--info-card {
        width: 100%;
        height: 290px;
        position: absolute;
        margin-left: -10px;
        box-shadow: 0px 3px 1px -2px rgb(0, 0, 0, 0.2), 0px 2px 2px 0px rgb(0, 0, 0, 0.14), 0px 1px 5px 0px rgb(0, 0, 0, 0.12), rgb(250, 250, 252) 0px 10px 0px 0px, rgb(250, 250, 252) 10px 0px 0px 0px, rgb(250, 250, 252) -10px 0px 0px 0px, rgb(250, 250, 252) 10px 10px 0px 0px, rgb(250, 250, 252) -10px 10px 0px 0px !important;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        margin-top: 9px;
        border-top: 1px solid $--bc;
    }
    .gantt .gantt-column > div {
        max-width: 120px;
    }
}</style>
